import { Variant } from "../../types/types";

export const hasReductionHistory = (variant: Variant) => {
  const reductionHistory = variant.price?.reductionHistory ?? [];
  return reductionHistory.some((history) => history.display);
};
